























































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import apiPiscine from '@/api/piscine'
import { toSubArray } from '@/utils/groupBy'
import ReadContent from '@/components/administration/piscine/read/ReadContent.vue'
import ReadDimension from '@/components/administration/piscine/read/ReadDimension.vue'
import ReadPiscineAdresse from '@/components/administration/piscine/read/ReadPiscineAdresse.vue'
import ReadPage from '@/components/administration/piscine/read/ReadPage.vue'
import ReadMns from '@/components/administration/piscine/read/ReadMns.vue'
import ReadImage from '@/components/administration/piscine/read/ReadImage.vue'
import ReadSeo from '@/components/administration/piscine/read/ReadSeo.vue'
import ReadTarif from '@/components/administration/piscine/read/ReadTarif.vue'
import ReadTemplateCours from '@/components/administration/piscine/read/ReadTemplateCours.vue'
import ReadGenerateCours from '@/components/administration/piscine/read/ReadGenerateCours.vue'

import { AloPiscine, getDefaultAloPiscine } from '@/models/alo/AloPiscine'
import { directPayloadQuery } from '@/utils/api'
import {DashboardAdmin} from '@/router/pages'
import { AloMedia, getDefaultAloMedia } from '@/models/alo/AloMedia'
import cloneDeep from 'clone-deep'


@Component({
  name: 'ModifyPiscine', 
  props: {
    piscineId:Number
  },
  components: { ReadContent,ReadDimension,ReadPiscineAdresse,ReadTarif,ReadTemplateCours,ReadPage,ReadSeo,ReadImage,ReadMns,ReadGenerateCours },
})

export default class ModifyPiscine extends Vue {
  piscineId!: number
  private showError = false    
  private rightDrawer = false
  private loading = false
  private tab = null

  get piscine(){
    return this.$store.myGetters.piscineDic[this.piscineId] || getDefaultAloPiscine()
  }

/*
  get defaultCrops(){
    return this.$store.myGetters.configuration.piscine.crops
  }
  get maxImages(){
    return this.$store.myGetters.configuration.piscine.maxImages
  }*/

  loadPiscine() {    
    this.loading = true    
    this.$store.myActions.ADM_PISCINE_DETAIL_REQUEST(this.piscineId.toString()).finally(() => {      
      this.loading = false
    })    
  }

  created(){
    this.loadPiscine()
  }  

  get arianeItems() {
    const arianeItems =  [
        DashboardAdmin,
        {
          text: 'Piscine',
          disabled: false,  
          to: {name:'AdminPiscine'},        
          exact:true
        }
      ]
    if(this.piscine) {
        arianeItems.push({
          text: this.piscine.libelle,
          disabled: true,             
          to: {name:''},                         
          exact:true
        })
    }
    return arianeItems;
  } 


}
